import { UserAgentApplication } from 'msal'

export const APPLICATION_CONFIG = {
  clientID: process.env.REACT_APP_MSAL_CLIENT_ID,
  authority: process.env.REACT_APP_MSAL_CONVERT_MERGE_SIGNIN_AUTHORITY,
  b2cScopes: [process.env.REACT_APP_MSAL_B2C_SCOPES],
  redirectUri: process.env.REACT_APP_MSAL_REDIRECT_URI,
  postLogoutRedirectUri: process.env.REACT_APP_MSAL_POST_LOGOUT_REDIRECT_URI,
  extraQueryParameters: {
    source_system: 'CSS',
    region: 'nyupstate',
    customer_type: 'home',
    switch_uri: process.env.REACT_APP_IAM_SWITCH_URL,
  },
  responseType: process.env.REACT_APP_MSAL_RESPONSE_TYPE,
  nonce: process.env.REACT_APP_MSAL_NONCE,
  cacheLocation: 'localStorage',
}

export const MSAL_AUTHENTICATION_PARAMETERS = {
  scopes: [process.env.REACT_APP_B2C_SCOPES],
  extraQueryParameters: {
    source_system: 'CSS',
    region: 'nyupstate',
    customer_type: 'home',
    switch_uri: process.env.REACT_APP_IAM_SWITCH_URL,
  },
}

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID,
    authority: process.env.REACT_APP_MSAL_CONVERT_MERGE_SIGNIN_AUTHORITY,
    validateAuthority: false,
    redirectUri: process.env.REACT_APP_MSAL_REDIRECT_URI,
    postLogoutRedirectUri: process.env.REACT_APP_MSAL_POST_LOGOUT_REDIRECT_URI,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    navigateFrameWait: 0,
  },
}

export const msalApp = new UserAgentApplication(msalConfig)
